"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var styles = (0, _makeStyles.default)(function (theme) {
  var _theme$palette, _theme$palette$primar, _theme$palette2, _theme$palette2$text, _theme$palette3, _theme$palette3$info, _theme$palette4, _theme$palette4$text, _theme$palette5, _theme$palette5$text;
  return {
    priceWrapper: {
      alignItems: "center",
      display: "flex",
      flexWrap: "wrap"
    },
    value: {
      color: (_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : (_theme$palette$primar = _theme$palette.primary) === null || _theme$palette$primar === void 0 ? void 0 : _theme$palette$primar.main,
      fontWeight: theme.typography.fontWeightBold,
      marginRight: theme.spacing(1.25)
    },
    original: {
      color: (_theme$palette2 = theme.palette) === null || _theme$palette2 === void 0 ? void 0 : (_theme$palette2$text = _theme$palette2.text) === null || _theme$palette2$text === void 0 ? void 0 : _theme$palette2$text.secondary,
      marginRight: theme.spacing(1),
      textDecoration: "line-through"
    },
    discountLabel: {
      color: (_theme$palette3 = theme.palette) === null || _theme$palette3 === void 0 ? void 0 : (_theme$palette3$info = _theme$palette3.info) === null || _theme$palette3$info === void 0 ? void 0 : _theme$palette3$info.main,
      fontSize: "0.875rem",
      fontWeight: theme.typography.fontWeightBold,
      marginTop: theme.spacing(0.5)
    },
    taxLabel: {
      color: (_theme$palette4 = theme.palette) === null || _theme$palette4 === void 0 ? void 0 : (_theme$palette4$text = _theme$palette4.text) === null || _theme$palette4$text === void 0 ? void 0 : _theme$palette4$text.secondary,
      fontSize: "0.75rem"
    },
    scaleUnitValue: {
      color: (_theme$palette5 = theme.palette) === null || _theme$palette5 === void 0 ? void 0 : (_theme$palette5$text = _theme$palette5.text) === null || _theme$palette5$text === void 0 ? void 0 : _theme$palette5$text.secondary,
      fontSize: "0.75rem",
      fontWeight: theme.typography.fontWeightBold,
      lineHeight: 1.5
    }
  };
});
var _default = styles;
exports.default = _default;